import { helperServices } from "../../shared/helper";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "/api";

// -------------------- Headers --------------------
function buildHeaders() {
  const token = helperServices.getAuthorization() || "";
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: token,
  };
}

// -------------------- Generic Request --------------------
function request(url, options) {
  return apiFetch(url, {
    ...options,
    headers: buildHeaders(),
  });
}

// -------------------- Doctors --------------------
function getDoctors() {
  return request(`${basePath}/doctors?limit=100`, {
    method: "GET",
  });
}

// -------------------- Rooms --------------------
function getRooms() {
  return request(`${basePath}/rooms`, {
    method: "GET",
  });
}

// -------------------- Packages --------------------
function getPackages() {
  return request(`${basePath}/packages`, {
    method: "GET",
  });
}

// -------------------- Package Services --------------------
function getPackageServices() {
  return request(`${basePath}/packageservices`, {
    method: "GET",
  });
}

function getPackageServicesByPackage(id) {
  return request(`${basePath}/packageservices/bypackage/${id}`, {
    method: "GET",
  });
}

function savePackageService(payload) {
  return request(`${basePath}/packageservices`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

function updatePackageService(id, payload) {
  return request(`${basePath}/packageservices/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

function deletePackageService(id) {
  return request(`${basePath}/packageservices/${id}`, {
    method: "DELETE",
  });
}

// -------------------- Entity (Generic CRUD) --------------------
function getById(type, id) {
  return request(`${basePath}/${type}/${id}`, {
    method: "GET",
  });
}

function create(type, payload, options = {}) {
  return request(`${basePath}/${type}`, {
    method: "POST",
    body: JSON.stringify(payload),
    ...options,
  });
}

function update(type, id, payload) {
  return request(`${basePath}/${type}/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

function upload(file) {
  const formData = new FormData();
  formData.append("file", file);

  return apiFetch(`${basePath}/upload`, {
    method: "POST",
    headers: {
      Authorization: helperServices.getAuthorization() || "",
    },
    body: formData,
  });
}

// -------------------- Export --------------------
const entityServices = {
  getDoctors,
  getRooms,
  getPackages,
  getPackageServices,
  getPackageServicesByPackage,
  savePackageService,
  updatePackageService,
  deletePackageService,
  getById,
  create,
  update,
  upload,
};

export default entityServices;